var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 163.5,
    r: 163.5,
    fill: "#B7C0EE",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1051 93.0407C25.8477 84.6229 31.7475 76.2105 40.4309 75.4657L249.299 57.5502C255.962 56.9787 262.1 61.2002 263.949 67.6276L306.482 215.442C308.764 223.37 303.73 231.542 295.623 233.071L89.4802 271.941C82.2854 273.297 75.2603 268.881 73.3639 261.809L28.1051 93.0407Z",
    fill: "white",
    fillOpacity: 0.6,
    stroke: "#4C5793",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.135 112.427C104.016 108.256 106.905 104.077 111.202 103.649L160.835 98.7031C164.135 98.3743 167.213 100.406 168.207 103.57L180.506 142.703C181.808 146.847 179.06 151.165 174.754 151.74L123.815 158.542C120.329 159.007 117.038 156.814 116.127 153.417L105.135 112.427Z",
    fill: "#B7C0EE",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.074 176.044C122.976 171.95 125.739 167.828 129.942 167.288L179.545 160.905C182.971 160.464 186.207 162.588 187.164 165.907L198.336 204.636C199.491 208.64 196.913 212.761 192.806 213.473L143.021 222.107C139.453 222.726 136.001 220.521 135.063 217.023L124.074 176.044Z",
    fill: "#B7C0EE",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.099 165.238C196.982 161.195 199.648 157.084 203.794 156.454L252.318 149.078C255.839 148.543 259.201 150.737 260.129 154.176L270.481 192.552C271.561 196.556 268.942 200.617 264.848 201.284L216.701 209.128C213.173 209.703 209.779 207.528 208.827 204.083L198.099 165.238Z",
    fill: "#B7C0EE",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.1 103.694C178.981 99.6673 181.617 95.5633 185.745 94.9066L235.389 87.009C238.879 86.4538 242.236 88.5867 243.215 91.9819L254.336 130.534C255.491 134.539 252.913 138.659 248.806 139.371L198.963 148.015C195.419 148.63 191.986 146.458 191.023 142.993L180.1 103.694Z",
    fill: "#B7C0EE",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6142 93.0744C20.354 84.6461 26.271 76.2262 34.9667 75.4971L249.319 57.5248C255.973 56.9669 262.096 61.1868 263.942 67.6045L306.463 215.375C308.751 223.326 303.683 231.516 295.546 233.015L83.9381 272.007C76.7596 273.33 69.7695 268.915 67.8788 261.865L22.6142 93.0744Z",
    stroke: "#4C5793",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 241L258.225 251.237C257.179 255.942 253.419 259.566 248.678 260.436L84.0911 290.657C81.1381 291.199 78.0892 290.615 75.546 289.019L60.4263 279.532C56.5014 277.07 54.345 272.567 54.8864 267.965L59 233",
    stroke: "#4C5793",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79 286L82.5 274.5",
    stroke: "#4C5793",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79 78L128.5 259.5",
    stroke: "#B7C0EE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.9941,
    y: 116.498,
    width: 36,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 40.9941 116.498)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 91.3203,
    width: 81.5539,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 104 91.3203)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.4611,
    y: 126.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 43.4611 126.061)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 161.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 54 161.061)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 135.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 46 135.061)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5389,
    y: 170.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 56.5389 170.061)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 198.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 64 198.061)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 144.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 49 144.061)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.5389,
    y: 179.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 59.5389 179.061)",
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 207.061,
    width: 35.5359,
    height: 4,
    rx: 2,
    transform: "rotate(-6.56217 67 207.061)",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubIcon);
export default __webpack_public_path__ + "static/media/hubIcon.41a831b7b7260fb52749b0d960ca18b2.svg";
export { ForwardRef as ReactComponent };